import React, { useState } from "react";
import { Image_Url } from "../../constants/imageUrl/ImageUrl";
import Paginations from "../../component/Pagination/PgmTextField";
import Loader from "../loaderComponent/Loader";
import NodataFound from "../../component/NodataFound";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";

const AddEditModule = ({
  tutorialListData,
  selectedCheckboxes,
  handleCheckboxChanges,
  count,
  page,
  handlePageChange,
  isLoadingTutorialList,
  OpenThumbnailPopup
}) => {
  const { t } = useTranslation();
  return (
    <div className="table-content">
      {isLoadingTutorialList ? (
        <Loader />
      ) : (
        <div className="tabledata">
          {tutorialListData?.length > 0 ? (
            <table className="table">
              <tr>
                <th className="tablesth"></th>
                <th className="tablesth"> {t('add_module.thumbnail')}</th>
                <th className="tablesth"> {t('add_module.tutorialTitle')}</th>
                <th className="tablesth">{t('add_module.description')}</th>
                <th className="tablesth">{t('add_module.fileTypeLabel')}</th>
              </tr>
              {tutorialListData.map((data, i) => (
                <tr key={data.id}>
                  <td className="tabletd">
                    <input
                      className="input_checkbox"
                      type="checkbox"
                      name="checkbox"
                      value={`checkbox${data.id}`}
                      checked={selectedCheckboxes.includes(data.id)}
                      onChange={(e) => handleCheckboxChanges(e, data.id)}
                    />
                  </td>
                  <td className="tabletd"  onClick={()=>OpenThumbnailPopup(data.attachment,data?.attachment_type.toLowerCase())}>
                    <img
                      height="77.78px"
                      width="126px"
                      className="thumbnaiils-produt"
                      src={data?.attachment_type.toLowerCase() === "pdf" ? Image_Url.PDF_THUMBNAIL : data?.attachment_type.toLowerCase() === "video" || data?.attachment_type.toLowerCase() === "scorm"
                      ? (data.video_thumbnail === null ? Image_Url.VIDEO_THUMBNAIL : data.video_thumbnail) : Image_Url.PDF_THUMBNAIL
                      }
                    />
                  </td>
                  <td className="tabletd">{data.title} </td>
                  <td className="tabletd"><Tooltip arrow title={String(data?.description).length>100?String(data.description):""}><div style={{padding:0,marginBottom:"-20px"}}>{String(data.description).substring(0,100) + (String(data?.description).length>100?"...":"")}</div></Tooltip> </td>
                  <td className="tabletd">{data.attachment_type}</td>
                </tr>
              ))}
            </table>
          ) : (
            <NodataFound />
          )}
        </div>
      )}
      <div className="add-module-pagination">
        <Paginations
          count={count}
          page={page}
          handlePageChange={handlePageChange}
        />
      </div>
    </div>
  );
};

export default AddEditModule;
